import React from 'react';


import useAccountId from '~/hooks/useAccountId';
import useActivatePremiumTrial from '~/hooks/useActivatePremiumTrial';
import useNavigation from '~/hooks/useNavigation';
import useUrlState from '~/hooks/useUrlState';

import {
	getRouterState,
} from '~/routing/router';



enum ExternalAction {
	ActivatePremiumTrial = 'activatepremiumtrial',
}



const ExternalActions: React.FC = () => {
	const accountId = useAccountId();
	const activatePremiumTrial = useActivatePremiumTrial(accountId);
	const navigation = useNavigation();
	const urlState = useUrlState();

	React.useEffect(
		() => {
			const state = getRouterState();
			const externalAction = state.params.external_action?.toLowerCase();

			if (externalAction === ExternalAction.ActivatePremiumTrial && accountId) {
				removeExternalActionParam(navigation, urlState);
				activatePremiumTrial();
			}
		},
		[
			accountId,
			activatePremiumTrial,
			navigation,
			urlState,
		],
	);

	return null;
};



function removeExternalActionParam(navigation, urlState): void {
	const routeParams = {
		...urlState.params,
	};

	delete routeParams.external_action;

	navigation.navigate({
		routeName: urlState.routeName,
		routeParams,
		options: {
			replace: true,
		},
	});
}



export default ExternalActions;
